import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ApiService } from 'src/app/components/shared/api.service';
import { localStorageService } from 'src/app/components/shared/localstorage.service';
import { MainService } from 'src/app/components/shared/main.service';
import { PasswordStrengthService, PasswordSpaceValidator } from 'src/app/components/shared/password-strength.service';
import { passwordValidator, SharedService } from 'src/app/components/shared/shared.service';
import { PermissionsService } from 'src/app/components/shared/permissions/permissions.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-new-password',
    templateUrl: './new-password.component.html',
    styleUrl: './new-password.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, NgClass, RouterLink]
})
export class NewPasswordComponent implements OnInit{
  public newPasswordForm: UntypedFormGroup;
  passwordStrength = 'Empty';
  validator: number[] = [];
  minLength : boolean = false;
  hasUpperCase: boolean = false;
  hasMaxChar: boolean = false;
  hasNumber : boolean = false;
  hasSpecialChar : boolean = false;
  hidePwd = false;
  hideConfirmPwd = false;
  showPassTooltip  = false
  totalStrength: number = 0;
  constructor(private _fb: UntypedFormBuilder, private _api: ApiService, private _local: localStorageService, public _shared: SharedService, private _router: Router, private main: MainService,private passwordStrengthService: PasswordStrengthService, private _permissions: PermissionsService) {
    this.newPasswordForm = this._fb.group({
      new_password: ['', [Validators.required, Validators.maxLength(50), passwordValidator(), PasswordSpaceValidator.cannotContainSpace]],
      confirm_password: ['', Validators.required]
    })
  }

  ngOnInit(): void {
    console.log('in');
    this.newPasswordForm.get('new_password')?.valueChanges.subscribe(password => {
      console.log('New Password:', password);
      // Contains uppercase letters (A-Z)
    if ((/[A-Z]/.test(password)) && (/[a-z]/.test(password))) {
      this.hasUpperCase = true;
    }else{
      this.hasUpperCase = false;
    }

    // Contains numbers (0-9)
    if (/[0-9]/.test(password)) {
      this.hasNumber = true;
    }else{
      this.hasNumber = false;
    }

    // Contains special characters (!@#$%^&*)
    if (/[^A-Za-z0-9]/.test(password)) {
      this.hasSpecialChar = true;
    }else{
        this.hasSpecialChar = false;
      }

    if (password.length >= 8 ) {
      this.hasMaxChar = true;
    }else{
      this.hasMaxChar = false;
    }
    this.totalStrength = (Number(this.hasUpperCase) + Number(this.hasNumber) + Number(this.hasSpecialChar) + Number(this.hasMaxChar))
      this.passwordStrength = this.passwordStrengthService.calculatePasswordStrength(password);
    });
    
    console.log(this.totalStrength)
  }

  submit() {
    // if (this.newPasswordForm.invalid) {
    //   this.newPasswordForm.markAsDirty();
    //   return;
    // }

    if (this.newPasswordForm.value.new_password != this.newPasswordForm.value.confirm_password) {
      this._shared.customPopups('New password and Confirm password should be same', 1);
      return
    }
    if (this.newPasswordForm.controls['new_password'].errors?.['cannotContainSpace'] ){
      this._shared.customPopups('Password must contain at least 8 characters, including 1 uppercase, 1 lowercase, 1 number, and 1 special character. Spaces are not allowed.', 2);
      return
    }
    if (this.newPasswordForm.controls['new_password'].value != this.newPasswordForm.controls['confirm_password'].value) {
      this._shared.customPopups('Passwords did not match', 2);
      return;
    }

    if (this.newPasswordForm.controls['new_password'].value.length < 8) {
      this._shared.customPopups('Password must contain at least 8 characters, including 1 uppercase, 1 lowercase, 1 number, and 1 special character. Spaces are not allowed.', 2);
      return;
    }
    
    if (!/[A-Z]/.test(this.newPasswordForm.controls['new_password'].value)) {
      this._shared.customPopups('Password must contain at least 8 characters, including 1 uppercase, 1 lowercase, 1 number, and 1 special character. Spaces are not allowed.', 2);
      return;
    }
    
    if (!/[a-z]/.test(this.newPasswordForm.controls['new_password'].value)) {
      this._shared.customPopups('Password must contain at least 8 characters, including 1 uppercase, 1 lowercase, 1 number, and 1 special character. Spaces are not allowed.', 2);
      return;
    }
    
    if (!/[0-9]/.test(this.newPasswordForm.controls['new_password'].value)) {
      this._shared.customPopups('Password must contain at least 8 characters, including 1 uppercase, 1 lowercase, 1 number, and 1 special character. Spaces are not allowed.', 2);
      return;
    }
    
    if (!/[^A-Za-z0-9]/.test(this.newPasswordForm.controls['new_password'].value)) {
      this._shared.customPopups('Password must contain at least 8 characters, including 1 uppercase, 1 lowercase, 1 number, and 1 special character. Spaces are not allowed.', 2);
      return;
    }

    const data = {
      reset_password_token: this._local.customGetItem('reset_password_token'),
      admin_email: this._local.customGetItem('reset_email').replace(/\s/g, '').toLowerCase(),
      new_password: this._shared.crypto(this.newPasswordForm.value.new_password),
    }

    this._api.api(data, 'auth/change_password').subscribe(response => {
        if (!response.is_error) {
          navigator.geolocation.getCurrentPosition(() => {});
          this._local.customClearAllItems();
          this._local.customSetItem('token', response.access_token);
          this._local.customSetItem('admin_profile', response.admin_profile ? response.admin_profile[0] : {});
          // Consumed once by MainLayoutComponent to auto-open the Connect
          // Gmail modal after a fresh login. See login.component.ts -- same
          // is_gmail_sync_enable gate applies here.
          const admin_profile_data = response.admin_profile ? response.admin_profile[0] : {};
          this._local.customSetItem('show_gmail_connect_modal', !!admin_profile_data.is_gmail_sync_enable);
          // Capability hydration: backend embeds capabilities + dashboards in
          // the change_password response (same shape as auth/email_login_v2),
          // so PermissionsService is ready before the post-redirect guard runs.
          this._permissions.setFromLoginResponse(response);
          this.main.fetchAdminList();
          if (response.menu && response.menu.length) {
            this.main.menu$.next(response.menu);
          }
          this._shared.dashboardMenuExist(response.menu).then(res => {
            // Sales-aware redirect mirrors login.component.ts: any user that
            // can see at least one sales dashboard or has lead-list scope
            // goes to the menu's first entry; otherwise they land on the
            // generic admin dashboard. Replaces the legacy `role_enum in
            // ['agent_l1','Team_lead_l1','agent_l2','Team_lead_l2',
            // 'sales_manager','agent_l3']` allowlist.
            const dashboards = this._permissions.dashboards;
            const hasAnySalesAccess = this._permissions.isWildcard
              || dashboards.l1 || dashboards.l2 || dashboards.l3
              || this._permissions.isAgent
              || this._permissions.isTeamLead
              || this._permissions.isManager;
            if (res && !hasAnySalesAccess) {
              this._router.navigate(['app', 'dashboard']);
            } else {
              this._router.navigate([response.menu[0]['path']]);
            }
          })
        }
    })
  }

}
